import { HttpRequest } from '@angular/common/http';

export class ExpepharmaApiHandler {
    request!: HttpRequest<any>;
    urlParams!: { [key: string]: string };
    constructor(public url: string) {}
}
